import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getVisibilitySearchListEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'post',
    url: `${API.VISIBILITY}/GetSearchResult`,
  });
};

export const getTrackingStatusDetailsEffects = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.VISIBILITY}/GetTrackingStatusDetails`,
  });
};

export const getProductInfoEffects = (params) => {
  return axiosInstance.request({
    method: 'get',
    params,
    url: `${API.VISIBILITY}/GetProductInformation`,
  });
};

export const getShipmentNotesAndDetailsEffects = (params) => {
  return axiosInstance.request({
    method: 'GET',
    params,
    url: `${API.VISIBILITY}/GetShipmentNotesAndDetails`,
  });
};

export const getShipperConsigneeDetailsEffects = (params) => {
  return axiosInstance.request({
    method: 'GET',
    params,
    url: `${API.VISIBILITY}/GetShipperConsignee`,
  });
};

export const updateShipmentTrackingDetailsEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'put',
    url: `${API.VISIBILITY}/UpdateShipmentTrackingDetails`,
  });
};

export const updateRefAndDockNoEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'put',
    url: `${API.VISIBILITY}/UpdateReferenceAndDockNo`,
  });
};

export const sendEmailEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'post',
    url: `${API.VISIBILITY}/SendEMail`,
  });
};

export const getVisibilityExportExcelEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'post',
    url: `${API.VISIBILITY}/GetVisibilityExportDetails`,
  });
};

let getShipperConsigneeSearchEffectsToken = () => {};
export const getShipperConsigneeSearchResult = (data) => {
  getShipperConsigneeSearchEffectsToken();
  return axiosInstance.request({
    cancelToken: new CancelToken(function executor(c) {
      getShipperConsigneeSearchEffectsToken = c;
    }),
    data,
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `${API.VISIBILITY}/GetShipperConsigneeSearch`,
  });
};

export const updateShipmentNoteEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'post',
    url: `${API.VISIBILITY}/UpdateShipmentNote`,
  });
};

export const updateShipmentDetailsEffects = (params) => {
  return axiosInstance.request({
    data: params,
    method: 'post',
    url: `${API.VISIBILITY}/UpdateShipmentDetails`,
  });
};
